import MDBox from "components/MDBox"
import MDButton from "components/MDButton";
import TableSkeleton from "components/TableSkeleton";
import { useEffect, useMemo, useState } from "react"
import { useMaterialUIController, setLoading } from "context";
import { useForm } from "react-hook-form";
import DataTable from "examples/Tables/DataTable";
import permissions from "permissions";
import { CircularProgress } from "@mui/material";
import { MaterialMasterExclusiveAPI } from "api/MaterialMasterExclusiveAPI";


export default function MaterialMasterTable(props) {

  const [materialMaster, setMaterialMaster] = useState([]);
  const [controller, dispatch] = useMaterialUIController();
  const { user, loading, admin } = controller;
  const { handleSubmit, formState: { isSubmitting } } = useForm();
  const { handleAlert } = props

  const currencyformatter = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
  });

  const numberFormater = new Intl.NumberFormat();

  const renderMaterialMaster = useMemo(() => {
    let rows = [];
    const columns = [
      { Header: "Producto", accessor: "codigo", align: "right" },
      { Header: "Descripcion", accessor: "descripcion", align: "left", },
      { Header: "Tipo", accessor: "tipo", align: "left" },
      { Header: "Grupo", accessor: "grupo", align: "left" },
      { Header: "Origen", accessor: "origen", align: "left" },
      { Header: "LT", accessor: "lt", align: "right", },
      { Header: "LS", accessor: "ls", align: "right", },
    ];

    materialMaster?.map((element) => {
      rows = [...rows,
      {
        codigo: element.codigo,
        descripcion: element.descripcion,
        tipo: element.tipo,
        grupo: element.grupo,
        origen: element.origen,
        lt: element.lt,
        ls: element.ls,
      }]
    });

    return (<DataTable
      table={{ columns, rows }}
      isSorted={true}
      entriesPerPage={true}
      showTotalEntries={true}
      noEndBorder
      canSearch={true}
    />
    );
  }, [materialMaster])


  const getMaterialMaster = () => {
    setLoading(dispatch, true)
    return MaterialMasterExclusiveAPI.index(true)
      .then(response => {
        setMaterialMaster(response.material_master)
      }).catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error')
        }
      }).finally(() => {
        setLoading(dispatch, false)
      });
  }


  return (
    <MDBox>
      <MDBox sx={{ display: 'flex', flexDirection: 'row-reverse', p: 3 }} component="form" role="form" onSubmit={handleSubmit(getMaterialMaster)}>
        {(user?.permissions?.includes(permissions.product_arrays[1]) || user?.role === admin) && (
          <MDButton type="submit" variant="gradient" color="info" disabled={isSubmitting}>
            {isSubmitting ? <CircularProgress size={18} color="white" /> : 'Consultars Maestro Materiales'}
          </MDButton>
        )}
      </MDBox>
      <MDBox>
        {loading ? <TableSkeleton></TableSkeleton> : renderMaterialMaster}
      </MDBox>
    </MDBox>
  )

}